// ---------------------------------------------------------------------------
// TidyCal booking-type configuration for the dedicated booking pages.
// Same account the original marketing Booking page used. Slugs below are
// the REAL booking types configured in the InterAct Globally TidyCal
// account, each confirmed live via the TidyCal API — never invented.
//
// All 4 dedicated services now have a real, owner-configured booking type
// (the owner created "Presentation Coaching - Free Consultation" and
// "L&D Partnership - Discovery Call" after the initial build — slugs
// supplied directly by the owner's own embed snippets and re-verified
// against the TidyCal API before use).
// ---------------------------------------------------------------------------

export const TIDYCAL_USERNAME = "interactglobally";

export const TIDYCAL_BOOKING_TYPES = {
  presentation: "presentation-consultation",
  executive_presence: "executive-presence-consultation",
  corporate: "corporate-training-discovery",
  ld_partnership: "ld-partnership-discovery",
};

export const tidycalEmbedPath = (service) => {
  const slug = TIDYCAL_BOOKING_TYPES[service];
  return slug ? `${TIDYCAL_USERNAME}/${slug}` : null;
};

export const tidycalBookingUrl = (service) => {
  const slug = TIDYCAL_BOOKING_TYPES[service];
  return slug ? `https://tidycal.com/${TIDYCAL_USERNAME}/${slug}` : null;
};
